export const formatCurrency = (value, options = {
    significantDigits: 0,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbol: '$',
}) => {
    let num = 0;
    if (typeof value === 'string') {
        if (value.trim() === '')
            return '';
        const parsed = Number.parseInt(value, 10);
        num = Number.isNaN(parsed) ? 0 : parsed;
    }
    else {
        num = value;
    }
    const stringVal = num.toFixed(options.significantDigits ?? 0);
    const parts = stringVal.split('.');
    const whole = parts[0] ?? '';
    const fractional = parts[1] ?? '';
    const decimalText = (options.significantDigits ?? 0) > 0 ? `${options.decimalSeparator}${fractional}` : '';
    return `${options.symbol}${whole.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousandsSeparator ?? ',')}${decimalText}`;
};
/**
 * `currency()` – common helper for displaying formatted currency.
 * (Alias of `formatCurrency` with the naming used in some apps.)
 */
export const currency = function (value, options = {
    significantDigits: 0,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbol: '$',
}) {
    return formatCurrency(value, options);
};
/**
 * Format currency in short form (e.g., $2.5k, $1.2M)
 */
export const formatCurrencyShort = (value) => {
    let num = 0;
    if (typeof value === 'string') {
        if (value.trim() === '')
            return '$0';
        const parsed = Number.parseInt(value, 10);
        num = Number.isNaN(parsed) ? 0 : parsed;
    }
    else {
        num = value;
    }
    if (num >= 1000000) {
        return `$${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
        return `$${(num / 1000).toFixed(1)}k`;
    }
    return `$${num}`;
};
